import {
    put, call, takeEvery,
  } from 'redux-saga/effects';
  import { VerionManagementDetail }
    from '../services';
  import { ActionTypes } from '../constants';
  
  async function fetchAsync(func: any, arg: any) {
    try {
      const response = arg !== null ? await func(arg) : await func();
      return response;
    } catch (error: any) {
      return {
        error: true,
        message: error.response.data.message,
        status: error.response.data.statusCode,
      };
    }
  }
  
  function* versionManagement(action: any): Generator {
    try {
      const data: any = yield call(fetchAsync,
        VerionManagementDetail.getVersionMangementDetail,
        action.payload);
      if (data.error) {
        if (data.status === 403) {
          yield put({ type: ActionTypes.LOGOUT_WITH_ERROR_REQUEST });
        } else {
          yield put({ type: ActionTypes.MANAGE_VERSION_UPDATE_ERROR, payload: data.message });
        }
      } else {
        yield put({ type: ActionTypes.MANAGE_VERSION_UPDATE_SUCCESS, payload: data.data.data });
      }
    } catch (e: any) {
      yield put({ type: ActionTypes.MANAGE_VERSION_UPDATE_ERROR, error: e.data });
    }
  }

  export function* watchManageVersionInfo() {
    yield takeEvery(ActionTypes.MANAGE_VERSION_UPDATE_REQUEST, versionManagement);
  }
  export default watchManageVersionInfo;
  